function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   color: ", ";\n   margin-bottom: 1.5rem;\n   display: inline-block;\n   width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import PropTypes from 'prop-types';
import styled from 'styled-components';
var ErrorSpan = styled.span(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.semanticColors.error;
});
ErrorSpan.propTypes = {
  children: PropTypes.node.isRequired
};
export { ErrorSpan };